export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:auth', ({ token }) => {
    const authToken = localStorage.getItem('auth-token')
    token.value = `JWT ${authToken}`
  })
})
